import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'components/common'
import { StockContext } from 'stores/StockStore'
import { AppContext } from 'stores/AppStore'
import FilterableTable from 'components/common/FilterableTable'

const AdipecStockTable = () => {
  const { t } = useTranslation()
  const { lengthUnit, convertToCurrentLengthUnit } = useContext(AppContext)
  const { filteredStockData: { tableData: data }} = useContext(StockContext)

  const columns = useMemo(() => [
    {
      Header: t('SAP Reference'),
      accessor: 'sapReference',
    },
    {
      Header: t('Material Description'),
      accessor: 'dscMaterial',
      customHeaderProps: {
        style: {
          minWidth: 350
        }
      },
    },
    {
      Header: t('Material Status'),
      id: 'dscStatusMaterial',
      accessor: ({ dscStatusMaterial }) => dscStatusMaterial && t(`stock.materialStatus.${dscStatusMaterial}`).toUpperCase(),
    },
    {
      Header: t('Pieces'),
      accessor: 'qtdPC',
      customCellProps: {
        style: {
          textAlign: 'center'
        }
      }
    },
    {
      Header: t('Total Estimated Length') + ` (${lengthUnit})`,
      id: 'totalEstimatedLength',
      accessor: ({ totalFootage }) => `${convertToCurrentLengthUnit(totalFootage/1000, totalFootage/304.8, lengthUnit)}`,
    },
    {
      Header: t('Location'),
      accessor: 'dscLocation'
    }
  ], [t, lengthUnit, convertToCurrentLengthUnit])

  return (
    <Card padding="0px" margin="0px 16px 16px" alignSelf="stretch">
      <FilterableTable columns={columns} data={data} />
    </Card>
  )
}

export default AdipecStockTable